import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "../components/Nav";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { StyleTag } from "./Signup";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.first_name}.`);
      nav(user.onboarded ? "/chat" : "/onboarding");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail && detail.includes("verify")) {
        nav(`/verify?email=${encodeURIComponent(email)}`);
      }
      toast.error(detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-12">
        <h1 className="font-display text-4xl text-slate-800">Welcome back.</h1>
        <p className="text-slate-600 mt-2">Zaf's been thinking about you.</p>
        <form onSubmit={submit} className="mt-8 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm space-y-5">
          <label className="block">
            <span className="uppercase tracking-[0.15em] text-xs font-semibold text-slate-500">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input zaf-focus mt-2" data-testid="login-email-input" />
          </label>
          <label className="block">
            <span className="uppercase tracking-[0.15em] text-xs font-semibold text-slate-500">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input zaf-focus mt-2" data-testid="login-password-input" />
          </label>
          <div className="text-right -mt-2">
            <Link to="/forgot-password" className="text-sm text-[#2E9D96] font-semibold hover:underline" data-testid="login-forgot-link">
              Forgot password?
            </Link>
          </div>
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#2E9D96] hover:bg-[#1F7B75] disabled:opacity-60 text-white font-semibold rounded-full py-3 transition-colors">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-sm text-slate-500 text-center">
            New here? <Link to="/signup" className="text-[#2E9D96] font-semibold">Create account</Link>
          </p>
        </form>
      </div>
      <StyleTag />
    </div>
  );
}
